import { useCallback, useRef } from "react";
import { findIngredients } from "./productRecipeApi";
import { IngredientOption, optionFor } from "./productRecipeEditor";
export default function useRecipeIngredientSearch(
  productId: number,
  fail: (cause: unknown) => void,
  clearError: () => void
) {
  const cache = useRef(new Map<string, Promise<IngredientOption[]>>());
  const failed = useRef(false);
  const reset = useCallback(() => cache.current.clear(), []);
  const search = (input: string): Promise<IngredientOption[]> => {
    const cached = cache.current.get(input);
    if (cached) return cached;
    // All ingredient rows share catalogue requests, including pending requests.
    const pending = findIngredients(productId, input)
      .then((products) => {
        if (failed.current) {
          failed.current = false;
          clearError();
        }
        return products.map(optionFor);
      })
      .catch((cause: unknown) => {
        cache.current.delete(input);
        failed.current = true;
        fail(cause);
        return [];
      });
    cache.current.set(input, pending);
    return pending;
  };
  return { search, resetSearch: reset };
}
